<template>
  <v-container fluid>
    <v-layout column>
        <v-flex xs12>
          <h2 class=".display-1" dark>Dienstleistungen</h2>
        </v-flex>
        <v-flex xs12>
          <v-layout row>
            <v-text-field
              v-model="searchTerm"
              class="mx-1" label="Suchen"
              prepend-inner-icon="search"
              solo
              clearable
            ></v-text-field>
            <v-btn dark
                   class="hidden-md-and-up"
                   @click="openNewService"
                   color="primary">
              <v-icon dark>library_add</v-icon>
            </v-btn>
            <v-btn depressed
                   medium
                   dark
                   class="hidden-sm-and-down"
                   @click="openNewService"
                   color="primary">
              Dienstleistung Anlegen
              <v-icon right dark>library_add</v-icon>
            </v-btn>
          </v-layout>
        </v-flex>
    </v-layout>
    <v-layout row fill-height>
        <v-flex>
          <v-list
            id="serviceList"
            two-line
            style="max-height: calc(100vh - 190px)"
            class="overflow-y-auto">
            <v-flex
              v-scroll:#serviceList="onScroll"
              align="center"
              justify="center"
            >
              <template v-for="(service,index) in services">
                <v-list-item v-if="index % 2 === 1"
                  :key="service.name" style="background-color: #B3E5FC40">
                  <v-list-item-content>
                    <v-list-item-title>{{service.name}}</v-list-item-title>
                    <v-list-item-subtitle>private Vergütung: {{toCurrency(service.privateHourFee)}} €</v-list-item-subtitle>
                    <v-list-item-subtitle>gewerbliche Vergütung: {{toCurrency(service.businessHourFee)}} €</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn text
                           icon
                           @click="openEditService(service)"
                           color="primary">
                      <v-icon>edit</v-icon>
                    </v-btn>
                  </v-list-item-action>
                  <v-list-item-action>
                    <v-btn text
                           icon
                           @click="openDeleteService(service)"
                           color="primary">
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
                <v-list-item v-else
                  :key="service.name">
                  <v-list-item-content>
                    <v-list-item-title>{{service.name}}</v-list-item-title>
                    <v-list-item-subtitle>private Vergütung: {{toCurrency(service.privateHourFee)}} €</v-list-item-subtitle>
                    <v-list-item-subtitle>gewerbliche Vergütung: {{toCurrency(service.businessHourFee)}} €</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn text
                           icon
                           @click="openEditService(service)"
                           color="primary">
                      <v-icon>edit</v-icon>
                    </v-btn>
                  </v-list-item-action>
                  <v-list-item-action>
                    <v-btn text
                           icon
                           @click="openDeleteService(service)"
                           color="primary">
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
                <v-divider
                v-if="index + 1 < services.length"
                :key="index"></v-divider>
              </template>
            </v-flex>
          </v-list>
          <data-loader></data-loader>
          <new-service-dialog :show="showNewServiceDialog" @close="closeNewService"></new-service-dialog>
          <edit-service-dialog :service="selectedService" :show="showEditServiceDialog"
                               @close="closeEditService"></edit-service-dialog>
          <delete-service-dialog :service="selectedService" :show="showDeleteServiceConfirmDialog"
                                 @close="closeDeleteService"></delete-service-dialog>
        </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import _ from 'lodash'
  import newServiceDialog from './NewServiceDialog'
  import editServiceDialog from './EditServiceDialog'
  import deleteServiceConfirmDialog from './DeleteServiceConfirmDialog'

  export default {
    name: 'Services',
    data () {
      return {
        searchTerm: '',
        page: 0,
        size: 50,
        bottom: false,
        showNewServiceDialog: false,
        showEditServiceDialog: false,
        showDeleteServiceConfirmDialog: false,
        selectedService: {
          name: '',
          privateHourFee: '',
          businessHourFee: ''
        }
      }
    },
    components: {
      'new-service-dialog': newServiceDialog,
      'edit-service-dialog': editServiceDialog,
      'delete-service-dialog': deleteServiceConfirmDialog
    },
    computed: {
      services: function () {
        return this.$store.getters.services
      },
      maxServices: function () {
        return this.$store.getters.maxServices
      }
    },
    watch: {
      bottom (bottom) {
        if (bottom && this.services.length < this.maxServices) {
          this.page++
          this.searchServices(this.searchTerm)
        }
      },
      searchTerm (searchTerm) {
        this.page = 0
        this.$store.dispatch('resetServices')
        if (searchTerm === null) {
          this.searchTerm = ''
          this.searchServices(this.searchTerm)
        } else {
          this.debouncedSearchServices(this.searchTerm)
        }
      }
    },
    created () {
      this.debouncedSearchServices = _.debounce(this.searchServices, 500)
      this.$store.dispatch('resetServices')
      this.searchServices(this.searchTerm)
    },
    methods: {
      searchServices: function (searchTerm) {
        this.$store.dispatch('loadServices',
          {
            searchTerms: searchTerm.split(' '),
            page: this.page,
            size: this.size
          })
      },
      onScroll: function (e) {
        const scrollY = e.target.scrollTop
        const visible = e.target.clientHeight
        const pageHeight = e.target.scrollHeight - 64.0 // window.scrollY not accurate on every device, we reduce the pageHeight by 15px
        const bottomOfPage = visible + scrollY >= pageHeight
        this.bottom = bottomOfPage || pageHeight < visible
      },
      openNewService: function () {
        this.showNewServiceDialog = true
      },
      closeNewService: function () {
        this.showNewServiceDialog = false
      },
      openEditService: function (service) {
        this.selectedService = service
        this.showEditServiceDialog = true
      },
      closeEditService: function () {
        this.showEditServiceDialog = false
      },
      openDeleteService: function (service) {
        this.selectedService = {id: service.id, name: service.name}
        this.showDeleteServiceConfirmDialog = true
      },
      closeDeleteService: function () {
        this.showDeleteServiceConfirmDialog = false
      },
      resetSearch: function () {
        this.pag = 0
        this.size = 50
        this.$store.dispatch('resetServices')
        this.searchTerm = ''
        this.debouncedSearchServices(this.searchTerm)
      },
      toCurrency: function (currencyFloat) {
        if ((typeof currencyFloat) === 'string') {
          return currencyFloat
        }

        return currencyFloat.toFixed(2).replace('.', ',')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Services/Services.vue